"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _invariant = _interopRequireDefault(require("invariant"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _withThemeProps = _interopRequireDefault(require("@sprinx/react-mui-components/withThemeProps"));

var _useShoppingCartContext = _interopRequireDefault(require("@sprinx/react-shopping-cart/useShoppingCartContext"));

var _useRedirect = _interopRequireDefault(require("@sprinx/react-routes/useRedirect"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _useMulticurrencyToPrice = _interopRequireDefault(require("@sprinx/react-globalize/useMulticurrencyToPrice"));

var _useShoppingCurrency = _interopRequireDefault(require("../../shop/useShoppingCurrency"));

var cond = function cond() {
  for (var _len = arguments.length, cnds = new Array(_len), _key = 0; _key < _len; _key++) {
    cnds[_key] = arguments[_key];
  }

  return function (v) {
    return (cnds.find(function (x) {
      return x[0](v);
    }) || [null, function () {
      return undefined;
    }])[1](v);
  };
};

var componentSettings = {
  name: 'SxShoppingCartAddToCart'
};
var useStyles = (0, _styles.makeStyles)({
  root: {},
  disabled: {},
  input: {}
}, componentSettings);

function AddToCart(_ref) {
  var cartSubject = _ref.cartSubject,
      pClasses = _ref.classes,
      className = _ref.className,
      component = _ref.component,
      componentProps = _ref.componentProps,
      disabled = _ref.disabled,
      forcePreventDecrement = _ref.forcePreventDecrement,
      pOnAddToCart = _ref.onAddToCart,
      product = _ref.product,
      pQuantityMax = _ref.quantityMax,
      pQuantityMin = _ref.quantityMin,
      pQuantityStep = _ref.quantityStep,
      pQuantityStepRounding = _ref.quantityStepRounding,
      ruleCode = _ref.ruleCode,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["cartSubject", "classes", "className", "component", "componentProps", "disabled", "forcePreventDecrement", "onAddToCart", "product", "quantityMax", "quantityMin", "quantityStep", "quantityStepRounding", "ruleCode"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var currency = (0, _useShoppingCurrency.default)();
  var getPrice = (0, _useMulticurrencyToPrice.default)(null, currency);
  var setRedirect = (0, _useRedirect.default)();

  var _useShoppingCartConte = (0, _useShoppingCartContext.default)(),
      AddToCartComponent = _useShoppingCartConte.AddToCartComponent,
      presentInCart = _useShoppingCartConte.presentInCart,
      preventDecrementRemoveSubject = _useShoppingCartConte.preventDecrementRemoveSubject,
      setSubject = _useShoppingCartConte.setSubject;

  (0, _invariant.default)(AddToCartComponent || component, 'AddToCart requires `AddToCartComponent` to be defined in ShoppingCartProvider.');
  (0, _invariant.default)(pOnAddToCart || cartSubject || product, 'AddToCart requires at least one of `onAddToCart`, `cartSubject` or `product` props to be defined.');

  var _presentInCart = presentInCart(cond([function () {
    return cartSubject;
  }, function () {
    return {
      subjectId: cartSubject.id,
      product: cartSubject.product
    };
  }], [function () {
    return true;
  }, function () {
    return {
      product: product,
      ruleCode: ruleCode
    };
  }])()),
      _presentInCart2 = (0, _slicedToArray2.default)(_presentInCart, 1),
      quantity = _presentInCart2[0];

  var handleAddToCart = _react.default.useCallback(function (nextQuantity) {
    if (preventDecrementRemoveSubject && !forcePreventDecrement && nextQuantity <= 0) {
      return;
    }

    cond([function () {
      return pOnAddToCart;
    }, pOnAddToCart], [function () {
      return cartSubject;
    }, function (qty) {
      return setSubject({
        subjectId: cartSubject.id,
        product: cartSubject.product,
        quantity: qty
      });
    }], [function () {
      return product;
    }, function (qty) {
      return setSubject({
        product: product,
        quantity: qty,
        ruleCode: ruleCode
      });
    }])(nextQuantity); // eslint-disable-next-line no-console
    // console.log('product add_to_cart', product);

    if (typeof window !== 'undefined' && product) {
      var salePrice = getPrice(product.salePrice || []);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        ecommerce: null
      });
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: currency.split('-')[0],
          value: salePrice,
          items: {
            item_id: product.id,
            item_name: t(product.name),
            affiliation: 'Online store',
            price: salePrice
          }
        }
      });
    }

    if (!quantity) {
      setRedirect({
        pathname: '/cart/content'
      });
    }
  }, [preventDecrementRemoveSubject, forcePreventDecrement, pOnAddToCart, product, quantity, cartSubject, setSubject, ruleCode, getPrice, currency, t, setRedirect]);

  var _cond = cond([function () {
    return pOnAddToCart;
  }, function () {
    return [pQuantityMax, pQuantityMin, pQuantityStep, pQuantityStepRounding];
  }], [function () {
    return cartSubject;
  }, function () {
    return [cartSubject.quantityMax, cartSubject.quantityMin, cartSubject.quantityStep, cartSubject.quantityStepRounding];
  }], [function () {
    return product;
  }, function () {
    return [product.quantityMax, product.quantityMin, product.quantityStep, product.quantityStepRounding];
  }])(),
      _cond2 = (0, _slicedToArray2.default)(_cond, 4),
      quantityMax = _cond2[0],
      quantityMin = _cond2[1],
      quantityStep = _cond2[2],
      quantityStepRounding = _cond2[3];

  var Component = component || AddToCartComponent;
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className, disabled && classes.disabled),
    classes: {
      input: classes.input
    },
    disabled: disabled,
    quantity: quantity,
    quantityMax: quantityMax,
    quantityMin: quantityMin,
    quantityStep: quantityStep,
    quantityStepRounding: quantityStepRounding,
    onAddToCart: handleAddToCart
  }, componentProps));
}

process.env.NODE_ENV !== "production" ? AddToCart.propTypes = {
  cartSubject: _propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    product: _propTypes.default.shape({
      name: _propTypes.default.string,
      salePrice: _propTypes.default.array
    }).isRequired,
    quantity: _propTypes.default.number,
    quantityMax: _propTypes.default.number,
    quantityMin: _propTypes.default.number,
    quantityStep: _propTypes.default.number,
    quantityStepRounding: _propTypes.default.oneOf(['up', 'down'])
  }),
  classes: _propTypes.default.shape({
    disabled: _propTypes.default.string,
    input: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,

  /**
   * Custom add to cart component. If defined overrides global ShoppingCartProvider setting.
   */
  component: _propTypes.default.elementType,

  /**
   * Prop specific for component addToCart
   *
   * props are sending to component you choose AddToCartButtonToQty, AddToCartInpButton, AddToCartInpToQty, AddToCartOnlyButton,
   * AddToCartQty, AddToCartQtyButton
   * */
  componentProps: _propTypes.default.shape({}),
  disabled: _propTypes.default.bool,

  /**
   * If `true` preventing of cart subject removing if quantity is `<= 0`.
   */
  forcePreventDecrement: _propTypes.default.bool,
  onAddToCart: _propTypes.default.func,
  product: _propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    name: _propTypes.default.string,
    quantityMax: _propTypes.default.number,
    quantityMin: _propTypes.default.number,
    quantityStep: _propTypes.default.number,
    quantityStepRounding: _propTypes.default.oneOf(['up', 'down']),
    salePrice: _propTypes.default.array
  }),
  quantityMax: _propTypes.default.number,
  quantityMin: _propTypes.default.number,
  quantityStep: _propTypes.default.number,
  quantityStepRounding: _propTypes.default.oneOf(['up', 'down']),
  ruleCode: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'medium', 'large'])
} : void 0;
AddToCart.defaultProps = {
  cartSubject: undefined,
  classes: undefined,
  className: undefined,
  component: undefined,
  componentProps: undefined,
  disabled: false,
  forcePreventDecrement: false,
  onAddToCart: undefined,
  product: undefined,
  quantityMax: undefined,
  quantityMin: undefined,
  quantityStep: undefined,
  quantityStepRounding: undefined,
  ruleCode: undefined,
  size: 'medium'
};

var _default = (0, _withThemeProps.default)(componentSettings)(AddToCart);

exports.default = _default;